import script from "./OapSustainability.vue?vue&type=script&lang=js"
export * from "./OapSustainability.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__